import React, { useEffect, useState } from "react";
import { Table, Button, Modal, message } from "antd";
import { generateClient } from "aws-amplify/data";
import type { Schema } from "../../amplify/data/resource";

const client = generateClient<Schema>();

interface LignaProject {
  id: string;
  data?: string;
  createdAt?: string;
  updatedAt?: string;
}

const LignaProjectList: React.FC = () => {
  const [projects, setProjects] = useState<LignaProject[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchProjects = async () => {
    setLoading(true);
    try {
      const res = await client.models.LignaProject.list();
      const items = res.data ?? [];
      items.sort((a, b) => a.id.localeCompare(b.id));
      setProjects(items);
    } catch (error) {
      console.error(error);
      message.error("Fehler beim Laden der Projekte");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id: string) => {
    Modal.confirm({
      title: "Eintrag wirklich löschen?",
      onOk: async () => {
        try {
          await client.models.LignaProject.delete({ id });
          message.success("Eintrag gelöscht");
          setProjects((prev) => prev.filter((p) => p.id !== id));
        } catch (err) {
          console.error(err);
          message.error("Löschen fehlgeschlagen");
        }
      },
    });
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a: LignaProject, b: LignaProject) => a.id.localeCompare(b.id),
    },
    {
      title: "Aktionen",
      key: "actions",
      render: (_: any, record: LignaProject) => (
        <Button danger onClick={() => handleDelete(record.id)}>
          Löschen
        </Button>
      ),
    },
  ];

  return (
    <Table<LignaProject>
      rowKey="id"
      dataSource={projects}
      columns={columns}
      loading={loading}
      pagination={false}
    />
  );
};

export default LignaProjectList;
